import { get, patch, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchTripList = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("trip?pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize + "&filterType=" + data.filterType + "&searchFilter=" + data.searchFilter);
    }, options);
};

export const useGetTripDetail = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("trip/" + data.tripId + "/" + data.scheduleId);
    }, options);
};

export const useFetchUserLocation = (options?: UseMutationOptions<any, any, { scheduleId: string, userIds: string }, any>) => {
    return useMutation(async ({ scheduleId, userIds }: { scheduleId: string, userIds: string }) => {
        return await get(`user/location/${scheduleId}?userIds=${userIds}`);
    }, options);
};

export const useTripCancel = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("trip/trip-cancel", data);
    }, options);
};

export const useTripDelete = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("trip/trip-delete", data);
    }, options);
};

export const useTripScheduleAgentReject = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("trip/schedule/agent/reject", data);
    }, options);
};

export const useTripScheduleAgentAccept = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("trip/schedule/agent/accept", data);
    }, options);
};

export const useFetchTripCancellationCharge = (tripId: string | undefined, options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get(`trip/${tripId}/cancellation-charge?scheduleId=${data.scheduleId}`);
    }, options);
};

export const useUpdatePaymentRefund = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("trip-payment/refund?tripId=" + data.tripId + "&scheduleId=" + data.scheduleId, data);
    }, options);
};

export const useUpdateTripExtension = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("trip/schedule/extend?scheduleId=" + data.scheduleId + "&extendedHours=" + data.extendedHours, data);
    }, options);
};

export const useGetPaymentDetails = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("trip-payment/trip-payment-status-for-extend?paymentId=" + data.paymentId + "&scheduleId=" + data.scheduleId);
    }, options);
};

export const useGetTripRunningDetails = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("trip/current/running?timeZoneOffset=" + data.timeZoneOffset + "&tripId=" + data.tripId + "&scheduleId=" + data.scheduleId);
    }, options);
};

export const useUpdateTripScheduleStart = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("trip/schedule/start", data);
    }, options);
};

export const useUpdateTripScheduleEnd = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("trip/schedule/end?scheduleId=" + data.scheduleId, {});
    }, options);
};

export const useGetAvailableAttendants = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("agent/availabilities-admin?tripId=" + data.tripId + "&referenceId=" + data.referenceId + "&pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize +  "&searchFilter=" + data.searchFilter);
    }, options);
};

export const useChangeAgent = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("trip/change-agent",data);
    }, options);
};

export const useUpdateTripPreferences = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("trip/preferences?tripId=" + data.tripId + "&scheduleIds=" + data.scheduleIds + "&isAdmin=" + data.isAdmin, data);
    }, options);
};

export const useCreateTripWithSchedule = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("trip/add", data);
    }, options);
};

export const useGetConfirmBookingDetails = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (tripId: string) => {
        return await get(`trip/confirm-booking?tripId=${tripId}`);
    }, options);
};

export const useConfirmBooking = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (tripId: string) => {
        return await patch(`trip/confirm-booking/${tripId}`, {});
    }, options);
};
